

























































import { Component, Vue } from 'vue-property-decorator';
import FoodTable from '@/components/FoodTable.vue';
import NewMealTable from '@/components/NewMealTable.vue';
import MealsTable from '@/components/MealsTable.vue';
import MealComponents from '@/components/MealComponents.vue';
import DayOverview from '@/components/DayOverview.vue';

@Component({
  components: {
    DayOverview,
    MealComponents,
    FoodTable,
    NewMealTable,
    MealsTable
  },
})
export default class Main extends Vue {
  private model: string = 'ingredients';

  get mealFood() {
    return this.$store.getters.getMealFood;
  }
}
